import { yupResolver } from '@hookform/resolvers/yup';
import { object, string, number } from 'yup';

import { validateLengthField } from '~/ui/configs/form/validation';
import {
  requiredField,
  fieldMax,
  fieldMaxThan,
  fieldOnlyNumbers,
  fieldMin,
} from '~/ui/constants/errorMessages';
import { IInitialValues } from '~/ui/pages/Clinics/ViewClinic/ActTeam/types';

export const DEFAULT_VALUES: IInitialValues = {
  name: '',
  clinicId: null,
  typeId: null,
  capacity: null,
  isShelterTeam: false,
  isCrisisTeam: false,
};

const validationSchema = object().shape({
  clinicId: number().required(requiredField),
  name: string().required(requiredField).test('length', fieldMax, validateLengthField),
  typeId: number().required(requiredField),
  capacity: string()
    .matches(/^[0-9]+$|^$/, {
      message: fieldOnlyNumbers,
      excludeEmptyString: true,
    })
    .test('min', fieldMin(0, 'Capacity'), value => {
      if (value) {
        return parseInt(value, 10) > 0;
      }
      return true;
    })
    .test('max', fieldMaxThan(10000, 'Capacity'), value => {
      if (value) {
        return parseInt(value, 10) <= 10000;
      }
      return true;
    })
    .required(requiredField),
});

export default yupResolver(validationSchema);
